<template>
  <div id="video_surv"><NuxtLayout /></div>
</template>
